export const TipoEntidadeOwner = {
  Cavalo: 1,
  Carreta: 2,
  MotoristaEmpresa: 3,
  MotoristaExterno: 4
} as const;

export const TipoProprietario = {
  Empresa: 1,
  Avulso: 2
} as const;

export interface IFrotaCavaloItem {
  PK_CAVA: number;
  TX_PLCA_CAVA?: string;
}

export interface IFrotaCarretaItem {
  PK_CRRT: number;
  TX_PLCA_CRRT?: string;
}

export interface IFrotaMotoristaItem {
  PK_MTRT: number;
  NU_TIPO_ENTD?: number;
  NM_USUA_MTRT?: string;
  TX_CPF_MTRT?: string;
}

export interface IGetFrotaEmpresaResponse {
  Cavalos: IFrotaCavaloItem[];
  Carretas: IFrotaCarretaItem[];
  Motoristas: IFrotaMotoristaItem[];
}

export interface ITransferirProprietarioEmpresaItem {
  NU_TIPO_ENTD: number;
  FK_ENTD: number;
}

export interface ITransferirProprietarioEmpresaRequest {
  FK_EPSA_ORIG?: number;
  FK_EPSA_DEST?: number;
  FL_ORIG_AVLS?: boolean;
  FL_DEST_AVLS?: boolean;
  FK_MTRT_EXTR_DEST?: number;
  FK_FUNC_OPER?: number;
  TX_OBSV?: string;
  Itens: ITransferirProprietarioEmpresaItem[];
}

export interface ITransferirProprietarioEmpresaItemResult {
  NU_TIPO_ENTD: number;
  FK_ENTD: number;
  TX_IDNT?: string;
  TX_MENS?: string;
}

export interface ITransferirProprietarioEmpresaResult {
  Sucesso: ITransferirProprietarioEmpresaItemResult[];
  Bloqueados: ITransferirProprietarioEmpresaItemResult[];
}

export interface IOwnerEmpresaHistItem {
  PK_OWNR_EPSA_HIST: number;
  NU_TIPO_ENTD: number;
  FK_ENTD: number;
  FK_EPSA?: number;
  NM_EPSA?: string;
  FK_MTRT_EXTR?: number;
  NM_MTRT_EXTR?: string;
  DT_INIC: string;
  DT_FIM?: string;
  FK_FUNC_OPER?: number;
  NM_FUNC_OPER?: string;
  TX_OBSV?: string;
}
